var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 106,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h315v106H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F8F8F8",
    cx: 13.039,
    cy: 12.428,
    rx: 12.423,
    ry: 12.428
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FE7345",
    cx: 47.824,
    cy: 12.428,
    rx: 12.423,
    ry: 12.428
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F8F8F8",
    cx: 82.609,
    cy: 12.428,
    rx: 12.423,
    ry: 12.428
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F8F8F8",
    cx: 117.394,
    cy: 12.428,
    rx: 12.423,
    ry: 12.428
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#0F5FBC",
    cx: 152.179,
    cy: 12.428,
    rx: 12.423,
    ry: 12.428
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E3E3E3",
    cx: 186.964,
    cy: 12.428,
    rx: 12.423,
    ry: 12.428
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F8F8F8",
    cx: 221.749,
    cy: 12.428,
    rx: 12.423,
    ry: 12.428
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E3E3E3",
    cx: 256.534,
    cy: 12.428,
    rx: 12.423,
    ry: 12.428
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F8F8F8",
    cx: 291.318,
    cy: 12.428,
    rx: 12.423,
    ry: 12.428
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 74)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F8F8F8",
    cx: 12.418,
    cy: 12.5,
    rx: 12.418,
    ry: 12.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E3E3E3",
    cx: 47.189,
    cy: 12.5,
    rx: 12.418,
    ry: 12.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F8F8F8",
    cx: 81.959,
    cy: 12.5,
    rx: 12.418,
    ry: 12.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F8F8F8",
    cx: 116.73,
    cy: 12.5,
    rx: 12.418,
    ry: 12.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F8F8F8",
    cx: 151.5,
    cy: 12.5,
    rx: 12.418,
    ry: 12.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F8F8F8",
    cx: 186.27,
    cy: 12.5,
    rx: 12.418,
    ry: 12.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F8F8F8",
    cx: 221.041,
    cy: 12.5,
    rx: 12.418,
    ry: 12.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F8F8F8",
    cx: 255.811,
    cy: 12.5,
    rx: 12.418,
    ry: 12.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFB820",
    cx: 290.582,
    cy: 12.5,
    rx: 12.418,
    ry: 12.5
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12 40)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E3E3E3",
    cx: 47.709,
    cy: 12.146,
    rx: 12.437,
    ry: 12.146
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E3E3E3",
    cx: 82.533,
    cy: 12.146,
    rx: 12.437,
    ry: 12.146
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5B6B7D",
    cx: 117.358,
    cy: 12.146,
    rx: 12.437,
    ry: 12.146
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E3E3E3",
    cx: 152.182,
    cy: 12.146,
    rx: 12.437,
    ry: 12.146
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F8F8F8",
    cx: 187.007,
    cy: 12.146,
    rx: 12.437,
    ry: 12.146
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#20CEFF",
    cx: 221.831,
    cy: 12.146,
    rx: 12.437,
    ry: 12.146
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F8F8F8",
    cx: 256.655,
    cy: 12.146,
    rx: 12.437,
    ry: 12.146
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F8F8F8",
    cx: 291.48,
    cy: 12.146,
    rx: 12.437,
    ry: 12.146
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F8F8F8",
    cx: 326.304,
    cy: 12.146,
    rx: 12.437,
    ry: 12.146
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F8F8F8",
    cx: 12.437,
    cy: 12.146,
    rx: 12.437,
    ry: 12.146
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderImage);
export default __webpack_public_path__ + "static/media/HeaderImage.cc482e05609e72e99a408a0f37139e9d.svg";
export { ForwardRef as ReactComponent };